export default __webpack_public_path__ + "static/media/notification_active.0fd2e792.svg";